import React from 'react'
import {AuthContext} from '../../lib/AuthContext';
import ParentComponent from '../../lib/ParentComponent';
import ar from '../../locale';
import EgyptianCoachExpectations from './Expectations';

export default class EgyptianCoach extends ParentComponent {
    
    static contextType = AuthContext;

    constructor(props, context) {
        super(props, context);
        this.state = {
            user: context.user,
        }
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    updateState = () => {
        this.setState(prev => {
            return {...prev}
        })
    };

    render() {
        let activeTab = this.props.match.params.key || 'expectations';
        return(
            <div className="page-wrapper">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card no-toolbar border-0">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-9 mt-2">
                                            <h2 className="card-title">{ar.you_r_trainer}</h2>
                                            <h5 className="card-subtitle">{ar.egy_coach_heading_test}</h5>
                                        </div>
                                        <div className="col-sm-3 mt-2 text-md-left">
                                            
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 mt-3">
                                            <ul className="nav nav-tabs" role="tablist">
                                                <li className="nav-item"> <a className={'nav-link pl-4 pr-4 ' + (activeTab === 'expectations' ? 'active' : '')} data-toggle="tab" href="#expectations" role="tab"><span className="hidden-sm-up"></span> <span className="hidden-xs-down">{ar.expectations}</span></a> </li>
                                            </ul>
                                            <div className="tab-content tabcontent-border">
                                                <div className="tab-pane p-20 active" id="expectations" role="tabpanel">
                                                   <EgyptianCoachExpectations {...this.props} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};
